function buildBrazilDddRange(start: number, end: number): readonly string[] {
  return Object.freeze(Array.from({ length: end - start + 1 }, (_, index) => String(start + index)));
}

export const BRAZIL_COUNTRY_CODE = 'BR';
export const BRAZIL_DDI = '55';

// Mantém os DDDs do Brasil agrupados por faixa para facilitar manutenção e revisão.
export const BRAZIL_PHONE_DDDS = Object.freeze([
  ...buildBrazilDddRange(11, 19),
  '21',
  '22',
  '24',
  '27',
  '28',
  ...buildBrazilDddRange(31, 35),
  '37',
  '38',
  ...buildBrazilDddRange(41, 49),
  '51',
  ...buildBrazilDddRange(53, 55),
  '61',
  '62',
  ...buildBrazilDddRange(64, 69),
  '71',
  ...buildBrazilDddRange(73, 75),
  '77',
  '79',
  ...buildBrazilDddRange(81, 89),
  ...buildBrazilDddRange(91, 99),
]);

export const BRAZIL_PHONE_DDD_SET = new Set(BRAZIL_PHONE_DDDS);
